import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { EventActivityLinkedPlanData } from '../hooks/useEventActivityLinkedPlanData'
import EventActivityPlanAbilityRow from './EventActivityPlanAbilityRow'

type Props = {
  activity: wowaudit.EventActivity
  open: boolean
  onOpenChange: (open: boolean) => void
  linkedPlanData?: EventActivityLinkedPlanData
  assignedSpellIds: number[]
}

const ViewerParticipantAssignmentAbilitiesDialog = ({
  activity,
  open,
  onOpenChange,
  linkedPlanData,
  assignedSpellIds,
}: Props) => {
  const encounterLabel =
    activity.encounter?.name ??
    activity.instance?.name ??
    'Activity assignments'
  const assignedSpellIdsSet = new Set(assignedSpellIds)
  const selectedRows = linkedPlanData?.selectedRows ?? []
  const linkedPlanAssignments = linkedPlanData?.linkedPlanAssignments ?? []
  const selectedAbilityRows = selectedRows
    .map((row) => {
      if (!assignedSpellIdsSet.has(row.spellId)) return null
      const ability = linkedPlanAssignments.find(
        (entry) => entry.spell_id === row.spellId,
      )
      if (!ability) return null
      return { row, ability }
    })
    .filter((entry): entry is NonNullable<typeof entry> => Boolean(entry))

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className='max-w-7xl w-fit'
        onOpenAutoFocus={(event) => {
          event.preventDefault()
        }}
      >
        <DialogHeader>
          <DialogTitle>{encounterLabel}</DialogTitle>
        </DialogHeader>
        {selectedAbilityRows.length === 0 ? (
          <div className='text-sm text-muted-foreground'>
            You don&apos;t have any assignments for this encounter.
          </div>
        ) : (
          <div className='max-h-[95vh] overflow-y-auto pr-1'>
            {selectedAbilityRows.map(({ row, ability }) => (
              <EventActivityPlanAbilityRow
                key={row.spellId}
                row={row}
                ability={ability}
                resolvedByScopeBoxKey={
                  linkedPlanData?.resolverResult.resolvedByScopeBoxKey ?? {}
                }
                selectedParticipants={
                  linkedPlanData?.selectedParticipants ?? []
                }
                onOverrideSelect={() => undefined}
                onResetAbilityOverrides={() => undefined}
                onSetAbilityHidden={() => undefined}
                isReadonly
              />
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ViewerParticipantAssignmentAbilitiesDialog
